import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类浏览', path: '/categories' },
  { label: '文章中心', path: '/articles' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-cloud-line text-lg text-white"></i>
            </div>
            <span className={`text-xl font-heading font-bold transition-colors ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              开云
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === item.path
                    ? scrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => navigate('/about')}
              className={`px-4 py-2 text-sm font-medium rounded-lg border transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled || !isHome
                  ? 'border-primary-300 text-primary-600 hover:bg-primary-50'
                  : 'border-white/40 text-white hover:bg-white/10'
              }`}
            >
              联系我们
            </button>
            <button
              onClick={() => navigate('/categories')}
              className="px-5 py-2 text-sm font-medium rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即体验
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-800 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="pt-2 flex gap-2">
              <button
                onClick={() => navigate('/about')}
                className="flex-1 px-4 py-2.5 text-sm font-medium rounded-lg border border-primary-300 text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </button>
              <button
                onClick={() => navigate('/categories')}
                className="flex-1 px-4 py-2.5 text-sm font-medium rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即体验
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}